import "./StormAtlasAdminPanel.css";

export default function StormAtlasAdminPanel() {
  return (
    <section className="ap" aria-label="O.R.A. Control Center">
      <div className="ap-section-header">
        <div className="ap-section-title">
          <span className="ap-ora-badge">O.R.A.</span>
          Control Center
        </div>
      </div>
    </section>
  );
}
